export const TEAMS = "teams";
export const FAMILY_VPN = "family";

// Payment wall logical Key
export const STRIPE_LOGICAL_KEY = "stripe";
export const PAYPAL_LOGICAL_KEY = "paypal";
export const GPAY_LOGICAL_KEY = "gpay";
export const PAYMENT_WALL_KEY = "paymentwall";
export const APPLE_KEY = "applepay";
export const COIN_PAYMENT_KEY = "coinpayment";

// PLG checkout varibles
export const PLG_CHECKOUT_V2 = "recurly-plg-v2";
export const PLG_CHECKOUT_V2_TEAMS = "recurly-plg-v2-teams";
export const PLG_CHECKOUT_TEMPLATES = [PLG_CHECKOUT_V2,PLG_CHECKOUT_V2_TEAMS];

// Paymane Wall Name Translation
export const paymentNameTranslation = {
    [STRIPE_LOGICAL_KEY]: "stripe_V2",
    [PAYPAL_LOGICAL_KEY]: "paypal",
    [GPAY_LOGICAL_KEY]: "gpay",
    [PAYMENT_WALL_KEY]: "paymentwall",
    [APPLE_KEY]: "applepay",
    [COIN_PAYMENT_KEY]: "coinpayment",
};
